webpackJsonp([1],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invoiceStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings__ = __webpack_require__(12);






var invoiceStore = {

	state: {
		invoices: []
	},

	init: function init() {
		var _this = this;

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('invoices').orderBy('number', 'desc').onSnapshot(function (data) {
				_this.state.invoices = data.docs.map(function (doc) {
					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, doc.data(), { id: doc.id });
				});

				resolve();
			}, function (error) {
				reject(error);
			});
		});
	},
	destroy: function destroy() {
		__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('invoices').onSnapshot(function () {})();
	},
	get: function get(id) {
		return this.state.invoices.find(function (i) {
			return i.id === id;
		});
	},
	save: function save(invoice) {
		return __WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('invoices').add(invoice);
	},
	update: function update(id, data) {
		return __WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('invoices').doc(id).update(data);
	},
	delete: function _delete(id) {
		return __WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('invoices').doc(id).delete();
	},
	createEmpty: function createEmpty() {
		return {
			type: 'invoice',
			client: {},
			issueDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
			issuePlace: __WEBPACK_IMPORTED_MODULE_4__settings__["a" /* settingStore */].state.invoice.defaultIssuePlace || '',
			deliveryDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
			paymentDeadline: __WEBPACK_IMPORTED_MODULE_4__settings__["a" /* settingStore */].state.invoice.defaultPaymentDeadline || 30,
			note: '',
			items: [{
				name: '',
				quantity: 1,
				price: 0.00
			}]
		};
	}
};

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase__ = __webpack_require__(8);




var settingStore = {

	state: {
		company: {
			name: '',
			address: '',
			owner: '',
			taxNumber: '',
			registrationNumber: '',
			classificationCode: '',
			bankAccount: '',
			responsiblePerson: '',
			phoneNumber: '',
			website: '',
			email: ''
		},
		invoice: {
			defaultIssuePlace: '',
			defaultPaymentDeadline: ''
		}
	},

	init: function init() {
		var _this = this;

		var companyPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('settings').doc('company').onSnapshot(function (doc) {
				if (doc && doc.exists) _this.state.company = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.company, doc.data());

				resolve();
			}, function (error) {
				reject(error);
			});
		});

		var invoicePromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('settings').doc('invoice').onSnapshot(function (doc) {
				if (doc && doc.exists) _this.state.invoice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.invoice, doc.data());

				resolve();
			}, function (error) {
				reject(error);
			});
		});

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([companyPromise, invoicePromise]);
	},
	destroy: function destroy() {
		__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('settings').onSnapshot(function () {})();
	},
	update: function update(data) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('settings').doc('company').set(data.company, { merge: true }), __WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('settings').doc('invoice').set(data.invoice, { merge: true })]);
	}
};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo2.39df80c.png";

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["money"] = money;
/* harmony export (immutable) */ __webpack_exports__["decimal"] = decimal;
/* harmony export (immutable) */ __webpack_exports__["date"] = date;
/* harmony export (immutable) */ __webpack_exports__["fromNow"] = fromNow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var LOCALE = 'sr-Latn-RS';
var CURRENCY = 'RSD';

function money(value) {
	return (value || 0.0).toLocaleString(LOCALE, {
		style: 'currency',
		currency: CURRENCY,
		useGrouping: false,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2 });
}

function decimal(value) {
	return (value || 0.0).toLocaleString(LOCALE, {
		style: 'decimal',
		useGrouping: false,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2 });
}

function date(value) {
	if (!value) return '';

	if (typeof value.toDate === 'function') return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value.toDate()).format('DD.MM.YYYY.');

	return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).format('DD.MM.YYYY.');
}

function fromNow(value) {
	if (!value) return '';

	return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).locale(LOCALE).fromNow();
}

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Signin__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Signin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Signin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Invoices__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Invoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Invoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InvoicePreview__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InvoicePreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_InvoicePreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Clients__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Clients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Clients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SalesBookPreview__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SalesBookPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SalesBookPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Settings__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_firebase__ = __webpack_require__(8);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/signin',
		name: 'Signin',
		component: __WEBPACK_IMPORTED_MODULE_2__components_Signin___default.a,
		meta: {
			public: true
		}
	}, {
		path: '/',
		name: 'Home',
		component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
	}, {
		path: '/invoices',
		name: 'Invoices',
		component: __WEBPACK_IMPORTED_MODULE_4__components_Invoices___default.a
	}, {
		path: '/invoices/:id',
		name: 'InvoicePreview',
		component: __WEBPACK_IMPORTED_MODULE_5__components_InvoicePreview___default.a
	}, {
		path: '/clients',
		name: 'Clients',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Clients___default.a
	}, {
		path: '/sales/:year',
		name: 'SalesBookPreview',
		component: __WEBPACK_IMPORTED_MODULE_7__components_SalesBookPreview___default.a
	}, {
		path: '/settings',
		name: 'Settings',
		component: __WEBPACK_IMPORTED_MODULE_8__components_Settings___default.a
	}, {
		path: '*',
		redirect: '/signin'
	}],
	linkActiveClass: 'active',
	linkExactActiveClass: 'active',
	mode: 'history'
});

router.beforeEach(function (to, from, next) {
	var currentUser = __WEBPACK_IMPORTED_MODULE_9__services_firebase__["a" /* auth */].currentUser;
	var requiresAuth = !to.matched.every(function (record) {
		return record.meta.public;
	});

	if (requiresAuth && !currentUser) next('/signin');else if (!requiresAuth && currentUser) next('/');else next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(296),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toasted__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatpickr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_flatpickr_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_l10n_sr__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_l10n_sr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_l10n_sr__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

for (var key in __WEBPACK_IMPORTED_MODULE_3__filters__) {
	__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter(key, __WEBPACK_IMPORTED_MODULE_3__filters__[key]);
}__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_toasted___default.a, {
	position: 'bottom-left',
	duration: 4000,
	theme: 'primary',
	className: 'toast',
	containerClass: 'toast-container'
});

__WEBPACK_IMPORTED_MODULE_5_flatpickr__["default"].localize(__WEBPACK_IMPORTED_MODULE_8_flatpickr_dist_l10n_sr__["Serbian"]);

__WEBPACK_IMPORTED_MODULE_5_flatpickr__["default"].setDefaults({
	dateFormat: 'Y-m-d',
	altFormat: 'd.m.Y.',
	altInput: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_flatpickr_component___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
	template: '<App/>'
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_firebase__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_invoices__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_settings__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',

	data: function data() {
		return {
			initialized: false,
			currentUser: {},
			invoiceState: __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].state
		};
	},


	computed: {
		years: function years() {
			return this.invoiceState.invoices.filter(function (i) {
				return i.deliveryDate !== null;
			}).map(function (i) {
				return __WEBPACK_IMPORTED_MODULE_4_moment___default()(i.deliveryDate.toDate()).year();
			}).filter(function (year, index, years) {
				return years.indexOf(year) === index;
			});
		}
	},

	beforeCreate: function beforeCreate() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__services_firebase__["a" /* auth */].onAuthStateChanged(function (user) {
			_this.initialized = true;

			if (user) {
				_this.currentUser = {
					email: user.email
				};

				if (_this.$route.path === '/signin') _this.$router.replace('/');
			} else {
				_this.currentUser = {};

				if (_this.$route.path !== '/signin') _this.$router.replace('/signin');
			}
		});
	},


	watch: {
		currentUser: function currentUser(user) {
			if (!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(user)) this.init();else this.destroy();
		}
	},

	methods: {
		init: function init() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__stores_clients__["a" /* clientStore */].init().catch(function (error) {
				_this2.$toasted.error('Nije uspelo učitavanje klijenata. ' + error.toString(), {
					icon: 'error_outline'
				});
			});

			__WEBPACK_IMPORTED_MODULE_3__stores_settings__["a" /* settingStore */].init().catch(function (error) {
				_this2.$toasted.error('Nije uspelo učitavanje podešavanja. ' + error.toString(), {
					icon: 'error_outline'
				});
			});

			__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].init().catch(function (error) {
				_this2.$toasted.error('Nije uspelo učitavanje faktura. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},
		destroy: function destroy() {
			__WEBPACK_IMPORTED_MODULE_2__stores_clients__["a" /* clientStore */].destroy();
			__WEBPACK_IMPORTED_MODULE_3__stores_settings__["a" /* settingStore */].destroy();
			__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].destroy();
		},
		signout: function signout() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0__services_firebase__["a" /* auth */].signOut().catch(function (error) {
				_this3.$toasted.error('Nije uspela odjava. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		}
	}
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_clients__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'clients',

	data: function data() {
		return {
			clientState: __WEBPACK_IMPORTED_MODULE_1__stores_clients__["a" /* clientStore */].state,
			currentClient: __WEBPACK_IMPORTED_MODULE_1__stores_clients__["a" /* clientStore */].createEmpty()
		};
	},
	mounted: function mounted() {
		var _this = this;

		window.jQuery(this.$refs.clientModal).on('hidden.bs.modal', function (e) {
			_this.currentClient = __WEBPACK_IMPORTED_MODULE_1__stores_clients__["a" /* clientStore */].createEmpty();
		});
	},


	methods: {
		edit: function edit(id) {
			this.currentClient = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_1__stores_clients__["a" /* clientStore */].get(id));
		},
		saveOrUpdate: function saveOrUpdate() {
			var _this2 = this;

			if (this.currentClient.id !== null) {
				this.update(this.currentClient).then(function () {
					window.jQuery(_this2.$refs.clientModal).modal('hide');
				});
			} else {
				this.save(this.currentClient).then(function () {
					window.jQuery(_this2.$refs.clientModal).modal('hide');
				});
			}
		},
		save: function save(client) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1__stores_clients__["a" /* clientStore */].save(client).then(function (docRef) {
				_this3.$toasted.success('Klijent sačuvan.', {
					icon: 'done'
				});
			}).catch(function (error) {
				_this3.$toasted.error('Nije uspelo čuvanje klijenta. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},
		update: function update(client) {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_1__stores_clients__["a" /* clientStore */].update(client.id, {
				name: client.name,
				address: client.address,
				taxNumber: client.taxNumber,
				registrationNumber: client.registrationNumber
			}).then(function () {
				_this4.$toasted.success('Izmene klijenta sačuvane.', {
					icon: 'done'
				});
			}).catch(function (error) {
				_this4.$toasted.error('Nije uspelo čuvanje izmena klijenta. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},
		remove: function remove(id) {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_1__stores_clients__["a" /* clientStore */].delete(id).then(function () {
				_this5.$toasted.success('Klijent obrisan.', {
					icon: 'done'
				});
			}).catch(function (error) {
				_this5.$toasted.error('Nije uspelo brisanje klijenta. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		}
	}
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stores_invoices__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'home',

	data: function data() {
		return {
			invoiceState: __WEBPACK_IMPORTED_MODULE_0__stores_invoices__["a" /* invoiceStore */].state
		};
	},


	computed: {
		totalIncome: function totalIncome() {
			return this.invoiceState.invoices.filter(function (invoice) {
				return invoice.type === 'invoice';
			}).reduce(function (total, invoice) {
				return (invoice.payments || []).reduce(function (total, payment) {
					return payment.amount + total;
				}, 0.0) + total;
			}, 0.0);
		},
		rolling365Income: function rolling365Income() {
			var offsetDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(365, 'days');

			return this.invoiceState.invoices.filter(function (invoice) {
				return invoice.type === 'invoice';
			}).filter(function (invoice) {
				return __WEBPACK_IMPORTED_MODULE_1_moment___default()(invoice.issueDate.toDate()).isAfter(offsetDate);
			}).reduce(function (total, invoice) {
				return (invoice.payments || []).reduce(function (total, payment) {
					return payment.amount + total;
				}, 0.0) + total;
			}, 0.0);
		},
		incomePerYear: function incomePerYear() {
			return __WEBPACK_IMPORTED_MODULE_2_lodash___default()(this.invoiceState.invoices.filter(function (invoice) {
				return invoice.type === 'invoice';
			})).groupBy(function (invoice) {
				return __WEBPACK_IMPORTED_MODULE_1_moment___default()(invoice.issueDate.toDate()).year();
			}).map(function (invoices, year) {
				return {
					year: year,
					income: invoices.reduce(function (total, invoice) {
						return (invoice.payments || []).reduce(function (total, payment) {
							return payment.amount + total;
						}, 0.0) + total;
					}, 0.0)
				};
			}).orderBy('year', 'desc').value();
		},
		totalDebt: function totalDebt() {
			return this.invoiceState.invoices.filter(function (invoice) {
				return invoice.type === 'invoice';
			}).reduce(function (total, invoice) {
				return invoice.total - (invoice.payments || []).reduce(function (total, payment) {
					return payment.amount + total;
				}, 0.0) + total;
			}, 0.0);
		}
	}
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stores_invoices__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_settings__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'invoice-page',

	data: function data() {
		return {
			invoice: {},
			company: {}
		};
	},


	computed: {
		advancePayments: function advancePayments() {
			var _this = this;

			if (!this.invoice.payments) return [];

			return this.invoice.payments.filter(function (payment) {
				return payment.date !== null && __WEBPACK_IMPORTED_MODULE_2_moment___default()(payment.date).isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()(_this.invoice.deliveryDate.toDate()));
			});
		}
	},

	created: function created() {
		this.init();
	},


	watch: {
		'$route': function $route(to, from) {
			if (to.name === 'InvoicePreview') {
				if (to.params.id) this.load(to.params.id);
			} else if (from.name === 'InvoicePreview') {
				this.invoice = {};
				this.company = {};
			}
		}
	},

	methods: {
		init: function init() {
			this.load(this.$route.params.id);
		},
		load: function load(id) {
			var invoice = __WEBPACK_IMPORTED_MODULE_0__stores_invoices__["a" /* invoiceStore */].get(id);

			if (invoice) this.invoice = invoice;else {
				this.$toasted.error('Nije uspelo učitavanje fakture.', {
					icon: 'error_outline'
				});
			}

			this.company = __WEBPACK_IMPORTED_MODULE_1__stores_settings__["a" /* settingStore */].state.company;
		}
	}
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_invoices__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_clients__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'invoices',

	data: function data() {
		return {
			invoiceState: __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].state,
			clientState: __WEBPACK_IMPORTED_MODULE_2__stores_clients__["a" /* clientStore */].state,
			currentInvoice: __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].createEmpty(),
			currentPayment: {}
		};
	},


	computed: {
		currentInvoiceTotal: function currentInvoiceTotal() {
			if (this.currentInvoice.items.length === 0) return 0.0;

			return this.currentInvoice.items.reduce(function (accumulator, currentValue) {
				return currentValue.quantity * currentValue.price + accumulator;
			}, 0.0);
		},
		nextInvoiceNumber: function nextInvoiceNumber() {
			return this.invoiceState.invoices.length + 1;
		},
		groupedInvoices: function groupedInvoices() {
			return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.groupBy(this.invoiceState.invoices, function (invoice) {
				return __WEBPACK_IMPORTED_MODULE_3_moment___default()(invoice.issueDate.toDate()).year();
			});
		},
		years: function years() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.groupedInvoices).sort().reverse();
		}
	},

	mounted: function mounted() {
		var _this = this;

		window.jQuery(this.$refs.invoiceModal).on('hidden.bs.modal', function (e) {
			_this.currentInvoice = __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].createEmpty();
		});

		window.jQuery(this.$refs.paymentModal).on('hidden.bs.modal', function (e) {
			_this.currentPayment = {};
		});

		window.jQuery(this.$refs.pro2InvoiceModal).on('hidden.bs.modal', function (e) {
			_this.currentInvoice = __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].createEmpty();
		});
	},


	methods: {
		saveInvoice: function saveInvoice() {
			var _this2 = this;

			var invoice = {
				number: this.nextInvoiceNumber,
				type: this.currentInvoice.type,
				client: this.currentInvoice.client,
				issueDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentInvoice.issueDate).toDate(),
				issuePlace: this.currentInvoice.issuePlace,
				deliveryDate: this.currentInvoice.type === 'invoice' ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentInvoice.deliveryDate).toDate() : null,
				paymentDeadline: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentInvoice.issueDate).add(this.currentInvoice.paymentDeadline, 'days').toDate(),
				note: this.currentInvoice.note,
				items: this.currentInvoice.items.map(function (item) {
					return {
						name: item.name,
						quantity: parseInt(item.quantity, 10),
						price: parseFloat(item.price),
						total: parseFloat(item.quantity * item.price)
					};
				}),
				total: parseFloat(this.currentInvoiceTotal)
			};

			__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].save(invoice).then(function (docRef) {
				_this2.$toasted.success('Faktura sačuvana.', {
					icon: 'done'
				});

				window.jQuery(_this2.$refs.invoiceModal).modal('hide');
			}).catch(function (error) {
				_this2.$toasted.error('Nije uspelo čuvanje fakture. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},
		removeInvoice: function removeInvoice(id) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].delete(id).then(function () {
				_this3.$toasted.success('Faktura obrisana.', {
					icon: 'done'
				});
			}).catch(function (error) {
				_this3.$toasted.error('Nije uspelo brisanje fakture. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},
		showAddPayment: function showAddPayment(invoiceId) {
			var invoice = __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].get(invoiceId);

			var paid = (invoice.payments || []).reduce(function (accumulator, currentValue) {
				return currentValue.amount + accumulator;
			}, 0.0);

			this.currentPayment = {
				date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
				amount: invoice.total - paid,
				invoiceId: invoiceId
			};
		},
		savePayment: function savePayment() {
			var _this4 = this;

			var invoice = __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].get(this.currentPayment.invoiceId);

			var payments = invoice.payments || [];

			payments.push({
				date: this.currentPayment.date,
				amount: parseFloat(this.currentPayment.amount)
			});

			__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].update(this.currentPayment.invoiceId, { payments: payments }).then(function () {
				_this4.$toasted.success('Uplata sačuvana.', {
					icon: 'done'
				});
			}).catch(function (error) {
				_this4.$toasted.error('Nije uspelo čuvanje uplate. ' + error.toString(), {
					icon: 'error_outline'
				});
			}).then(function () {
				window.jQuery(_this4.$refs.paymentModal).modal('hide');
			});
		},
		removePayment: function removePayment(invoiceId, index) {
			var _this5 = this;

			var invoice = __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].get(invoiceId);

			__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].update(invoiceId, { payments: invoice.payments.splice(index, 1) }).then(function () {
				_this5.$toasted.success('Uplata obrisana.', {
					icon: 'done'
				});
			}).catch(function (error) {
				_this5.$toasted.error('Nije uspelo brisanje uplate. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},
		addInvoiceItem: function addInvoiceItem() {
			this.currentInvoice.items.push({
				name: '',
				quantity: 1,
				price: 0.00
			});
		},
		removeInvoiceItem: function removeInvoiceItem(index) {
			this.currentInvoice.items.splice(index, 1);
		},
		showConvertProToInvoice: function showConvertProToInvoice(invoiceId) {
			var invoice = __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].get(invoiceId);

			this.currentInvoice.referenceProinvoice = invoice.id;
			this.currentInvoice.issueDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
			this.currentInvoice.deliveryDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
		},
		convertProToInvoice: function convertProToInvoice() {
			var _this6 = this;

			var proinvoice = __WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].get(this.currentInvoice.referenceProinvoice);

			var invoice = {
				number: this.nextInvoiceNumber,
				type: 'invoice',
				client: proinvoice.client,
				issueDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentInvoice.issueDate).toDate(),
				issuePlace: proinvoice.issuePlace,
				deliveryDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentInvoice.deliveryDate).toDate(),
				paymentDeadline: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.currentInvoice.issueDate).add(this.currentInvoice.paymentDeadline, 'days').toDate(),
				note: this.currentInvoice.note,
				items: proinvoice.items,
				total: proinvoice.total,
				referenceProinvoice: this.currentInvoice.referenceProinvoice,
				payments: proinvoice.payments || null
			};

			__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].save(invoice).then(function (docRef) {
				_this6.$toasted.success('Faktura sačuvana.', {
					icon: 'done'
				});

				__WEBPACK_IMPORTED_MODULE_1__stores_invoices__["a" /* invoiceStore */].update(_this6.currentInvoice.referenceProinvoice, { referenceInvoice: docRef.id }).catch(function (error) {
					_this6.$toasted.error('Nije uspelo označavanje referentne profakture. ' + error.toString(), {
						icon: 'error_outline'
					});
				}).then(function () {
					window.jQuery(_this6.$refs.pro2InvoiceModal).modal('hide');
				});
			}).catch(function (error) {
				_this6.$toasted.error('Nije uspelo čuvanje fakture. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		},
		isDeadlinePassed: function isDeadlinePassed(deadline) {
			return __WEBPACK_IMPORTED_MODULE_3_moment___default()(deadline).isSameOrBefore();
		},
		isInvoicePaid: function isInvoicePaid(invoice) {
			return (invoice.payments || []).reduce(function (accumulator, currentValue) {
				return currentValue.amount + accumulator;
			}, 0.0) >= invoice.total;
		}
	}
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stores_invoices__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_settings__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'sales-book-preview',

	data: function data() {
		return {
			invoices: [],
			company: {}
		};
	},
	created: function created() {
		this.init();
	},


	watch: {
		'$route': function $route(to, from) {
			if (to.name === 'SalesBookPreview') {
				if (to.params.year) this.load(to.params.year);
			} else if (from.name === 'SalesBookPreview') {
				this.invoices = [];
				this.company = {};
			}
		}
	},

	methods: {
		init: function init() {
			this.load(this.$route.params.year);
		},
		load: function load(year) {
			this.invoices = __WEBPACK_IMPORTED_MODULE_0__stores_invoices__["a" /* invoiceStore */].state.invoices.filter(function (i) {
				return i.type === 'invoice' && __WEBPACK_IMPORTED_MODULE_2_moment___default()(i.deliveryDate.toDate()).year() === parseInt(year);
			}).sort(function (i1, i2) {
				return i1.number < i2.number ? -1 : i1.number > i2.number ? 1 : 0;
			}) || [];

			this.company = __WEBPACK_IMPORTED_MODULE_1__stores_settings__["a" /* settingStore */].state.company;
		}
	}
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stores_settings__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'settings',

	data: function data() {
		return {
			settingState: __WEBPACK_IMPORTED_MODULE_0__stores_settings__["a" /* settingStore */].state
		};
	},


	methods: {
		save: function save() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__stores_settings__["a" /* settingStore */].update(this.settingState).then(function () {
				_this.$toasted.success('Sačuvane izmene podešavanja.', {
					icon: 'done'
				});
			}).catch(function (error) {
				_this.$toasted.error('Nije uspelo čuvanje izmena podešavanja. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		}
	}
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_firebase__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'signin',

	data: function data() {
		return {
			email: '',
			password: ''
		};
	},


	methods: {
		signin: function signin() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__services_firebase__["a" /* auth */].signInWithEmailAndPassword(this.email, this.password).then(function () {
				_this.password = '';
			}).catch(function (error) {
				_this.$toasted.error('Nije uspela prijava. ' + error.toString(), {
					icon: 'error_outline'
				});
			});
		}
	}
});

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clientStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase__ = __webpack_require__(8);




var clientStore = {

	state: {
		clients: []
	},

	init: function init() {
		var _this = this;

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('clients').orderBy('name').onSnapshot(function (data) {
				_this.state.clients = data.docs.map(function (doc) {
					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, doc.data(), { id: doc.id });
				});

				resolve();
			}, function (error) {
				reject(error);
			});
		});
	},
	destroy: function destroy() {
		__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('clients').onSnapshot(function () {})();
	},
	get: function get(id) {
		return this.state.clients.find(function (c) {
			return c.id === id;
		});
	},
	save: function save(client) {
		return __WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('clients').add(client);
	},
	update: function update(id, data) {
		return __WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('clients').doc(id).update(data);
	},
	delete: function _delete(id) {
		__WEBPACK_IMPORTED_MODULE_2__services_firebase__["b" /* db */].collection('clients').doc(id).delete();
	},
	createEmpty: function createEmpty() {
		return {
			id: null,
			name: '',
			address: '',
			taxNumber: '',
			registrationNumber: ''
		};
	}
};

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 58,
	"./af.js": 58,
	"./ar": 66,
	"./ar-dz": 59,
	"./ar-dz.js": 59,
	"./ar-kw": 60,
	"./ar-kw.js": 60,
	"./ar-ly": 61,
	"./ar-ly.js": 61,
	"./ar-ma": 62,
	"./ar-ma.js": 62,
	"./ar-ps": 63,
	"./ar-ps.js": 63,
	"./ar-sa": 64,
	"./ar-sa.js": 64,
	"./ar-tn": 65,
	"./ar-tn.js": 65,
	"./ar.js": 66,
	"./az": 67,
	"./az.js": 67,
	"./be": 68,
	"./be.js": 68,
	"./bg": 69,
	"./bg.js": 69,
	"./bm": 70,
	"./bm.js": 70,
	"./bn": 72,
	"./bn-bd": 71,
	"./bn-bd.js": 71,
	"./bn.js": 72,
	"./bo": 73,
	"./bo.js": 73,
	"./br": 74,
	"./br.js": 74,
	"./bs": 75,
	"./bs.js": 75,
	"./ca": 76,
	"./ca.js": 76,
	"./cs": 77,
	"./cs.js": 77,
	"./cv": 78,
	"./cv.js": 78,
	"./cy": 79,
	"./cy.js": 79,
	"./da": 80,
	"./da.js": 80,
	"./de": 83,
	"./de-at": 81,
	"./de-at.js": 81,
	"./de-ch": 82,
	"./de-ch.js": 82,
	"./de.js": 83,
	"./dv": 84,
	"./dv.js": 84,
	"./el": 85,
	"./el.js": 85,
	"./en-au": 86,
	"./en-au.js": 86,
	"./en-ca": 87,
	"./en-ca.js": 87,
	"./en-gb": 88,
	"./en-gb.js": 88,
	"./en-ie": 89,
	"./en-ie.js": 89,
	"./en-il": 90,
	"./en-il.js": 90,
	"./en-in": 91,
	"./en-in.js": 91,
	"./en-nz": 92,
	"./en-nz.js": 92,
	"./en-sg": 93,
	"./en-sg.js": 93,
	"./eo": 94,
	"./eo.js": 94,
	"./es": 98,
	"./es-do": 95,
	"./es-do.js": 95,
	"./es-mx": 96,
	"./es-mx.js": 96,
	"./es-us": 97,
	"./es-us.js": 97,
	"./es.js": 98,
	"./et": 99,
	"./et.js": 99,
	"./eu": 100,
	"./eu.js": 100,
	"./fa": 101,
	"./fa.js": 101,
	"./fi": 102,
	"./fi.js": 102,
	"./fil": 103,
	"./fil.js": 103,
	"./fo": 104,
	"./fo.js": 104,
	"./fr": 107,
	"./fr-ca": 105,
	"./fr-ca.js": 105,
	"./fr-ch": 106,
	"./fr-ch.js": 106,
	"./fr.js": 107,
	"./fy": 108,
	"./fy.js": 108,
	"./ga": 109,
	"./ga.js": 109,
	"./gd": 110,
	"./gd.js": 110,
	"./gl": 111,
	"./gl.js": 111,
	"./gom-deva": 112,
	"./gom-deva.js": 112,
	"./gom-latn": 113,
	"./gom-latn.js": 113,
	"./gu": 114,
	"./gu.js": 114,
	"./he": 115,
	"./he.js": 115,
	"./hi": 116,
	"./hi.js": 116,
	"./hr": 117,
	"./hr.js": 117,
	"./hu": 118,
	"./hu.js": 118,
	"./hy-am": 119,
	"./hy-am.js": 119,
	"./id": 120,
	"./id.js": 120,
	"./is": 121,
	"./is.js": 121,
	"./it": 123,
	"./it-ch": 122,
	"./it-ch.js": 122,
	"./it.js": 123,
	"./ja": 124,
	"./ja.js": 124,
	"./jv": 125,
	"./jv.js": 125,
	"./ka": 126,
	"./ka.js": 126,
	"./kk": 127,
	"./kk.js": 127,
	"./km": 128,
	"./km.js": 128,
	"./kn": 129,
	"./kn.js": 129,
	"./ko": 130,
	"./ko.js": 130,
	"./ku": 132,
	"./ku-kmr": 131,
	"./ku-kmr.js": 131,
	"./ku.js": 132,
	"./ky": 133,
	"./ky.js": 133,
	"./lb": 134,
	"./lb.js": 134,
	"./lo": 135,
	"./lo.js": 135,
	"./lt": 136,
	"./lt.js": 136,
	"./lv": 137,
	"./lv.js": 137,
	"./me": 138,
	"./me.js": 138,
	"./mi": 139,
	"./mi.js": 139,
	"./mk": 140,
	"./mk.js": 140,
	"./ml": 141,
	"./ml.js": 141,
	"./mn": 142,
	"./mn.js": 142,
	"./mr": 143,
	"./mr.js": 143,
	"./ms": 145,
	"./ms-my": 144,
	"./ms-my.js": 144,
	"./ms.js": 145,
	"./mt": 146,
	"./mt.js": 146,
	"./my": 147,
	"./my.js": 147,
	"./nb": 148,
	"./nb.js": 148,
	"./ne": 149,
	"./ne.js": 149,
	"./nl": 151,
	"./nl-be": 150,
	"./nl-be.js": 150,
	"./nl.js": 151,
	"./nn": 152,
	"./nn.js": 152,
	"./oc-lnc": 153,
	"./oc-lnc.js": 153,
	"./pa-in": 154,
	"./pa-in.js": 154,
	"./pl": 155,
	"./pl.js": 155,
	"./pt": 157,
	"./pt-br": 156,
	"./pt-br.js": 156,
	"./pt.js": 157,
	"./ro": 158,
	"./ro.js": 158,
	"./ru": 159,
	"./ru.js": 159,
	"./sd": 160,
	"./sd.js": 160,
	"./se": 161,
	"./se.js": 161,
	"./si": 162,
	"./si.js": 162,
	"./sk": 163,
	"./sk.js": 163,
	"./sl": 164,
	"./sl.js": 164,
	"./sq": 165,
	"./sq.js": 165,
	"./sr": 167,
	"./sr-cyrl": 166,
	"./sr-cyrl.js": 166,
	"./sr.js": 167,
	"./ss": 168,
	"./ss.js": 168,
	"./sv": 169,
	"./sv.js": 169,
	"./sw": 170,
	"./sw.js": 170,
	"./ta": 171,
	"./ta.js": 171,
	"./te": 172,
	"./te.js": 172,
	"./tet": 173,
	"./tet.js": 173,
	"./tg": 174,
	"./tg.js": 174,
	"./th": 175,
	"./th.js": 175,
	"./tk": 176,
	"./tk.js": 176,
	"./tl-ph": 177,
	"./tl-ph.js": 177,
	"./tlh": 178,
	"./tlh.js": 178,
	"./tr": 179,
	"./tr.js": 179,
	"./tzl": 180,
	"./tzl.js": 180,
	"./tzm": 182,
	"./tzm-latn": 181,
	"./tzm-latn.js": 181,
	"./tzm.js": 182,
	"./ug-cn": 183,
	"./ug-cn.js": 183,
	"./uk": 184,
	"./uk.js": 184,
	"./ur": 185,
	"./ur.js": 185,
	"./uz": 187,
	"./uz-latn": 186,
	"./uz-latn.js": 186,
	"./uz.js": 187,
	"./vi": 188,
	"./vi.js": 188,
	"./x-pseudo": 189,
	"./x-pseudo.js": 189,
	"./yo": 190,
	"./yo.js": 190,
	"./zh-cn": 191,
	"./zh-cn.js": 191,
	"./zh-hk": 192,
	"./zh-hk.js": 192,
	"./zh-mo": 193,
	"./zh-mo.js": 193,
	"./zh-tw": 194,
	"./zh-tw.js": 194
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(291),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2252beb6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(267)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(294),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43537a12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(290),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(295),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-512071ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(293),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(292),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e6779d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(297),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da4e7ed6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-page mx-auto"
  }, [_c('div', {
    staticClass: "container-fluid bg-light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.company.name))]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.company.address) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("PIB")]), _vm._v(" " + _vm._s(_vm.company.taxNumber) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Matični broj")]), _vm._v(" " + _vm._s(_vm.company.registrationNumber) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Tekući račun")]), _vm._v(" " + _vm._s(_vm.company.bankAccount) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col text-right"
  }, [(_vm.invoice.client) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.invoice.client.name))]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.invoice.client.address) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("PIB")]), _vm._v(" " + _vm._s(_vm.invoice.client.taxNumber) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Matični broj")]), _vm._v(" " + _vm._s(_vm.invoice.client.registrationNumber) + "\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-center pt-4"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('h1', {
    staticClass: "display-number"
  }, [_vm._v(_vm._s((_vm.invoice.type === 'proinvoice') ? 'Predračun' : 'Račun') + " "), _c('strong', [_vm._v(_vm._s(_vm.invoice.number))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('p', [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Datum izdavanja")]), _vm._v(" " + _vm._s(_vm._f("date")(_vm.invoice.issueDate)) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Mesto izdavanja")]), _vm._v(" " + _vm._s(_vm.invoice.issuePlace) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.type === 'invoice'),
      expression: "invoice.type === 'invoice'"
    }]
  }, [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Datum prometa")]), _vm._v(" " + _vm._s(_vm._f("date")(_vm.invoice.deliveryDate))), _c('br')]), _vm._v(" "), _c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Rok za plaćanje")]), _vm._v(" " + _vm._s(_vm._f("date")(_vm.invoice.paymentDeadline)) + "\n\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.invoice.items), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.price)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.total)))])])
  }), 0)]), _vm._v(" "), _c('h5', {
    staticClass: "text-right"
  }, [_vm._v("Ukupno "), _c('span', {
    staticClass: "badge badge-secondary badge-price"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.invoice.total)))])]), _vm._v(" "), (_vm.advancePayments.length > 0) ? _c('div', {
    staticClass: "text-right pt-3"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Avansne uplate:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.advancePayments), function(payment) {
    return _c('li', {
      staticClass: "list-inline-item"
    }, [_vm._v(_vm._s(_vm._f("date")(payment.date)) + " "), _c('strong', [_vm._v(_vm._s(_vm._f("money")(payment.amount)))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company.responsiblePerson),
      expression: "company.responsiblePerson"
    }],
    staticClass: "text-right pt-5"
  }, [_c('p', [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v("Odgovorno lice:")]), _vm._v(" " + _vm._s(_vm.company.responsiblePerson))])]), _vm._v(" "), _c('div', {
    staticClass: "text-right pt-1"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.note),
      expression: "invoice.note"
    }],
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.invoice.note))]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('footer', {
    staticClass: "fixed-bottom bg-dark text-light text-center small font-weight-light"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.company.email))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.company.phoneNumber))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('img', {
    staticClass: "img-logo mb-2",
    attrs: {
      "src": __webpack_require__(197),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Naziv usluge")]), _vm._v(" "), _c('th', [_vm._v("Količina")]), _vm._v(" "), _c('th', [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ukupno")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "small text-muted"
  }, [_vm._v("Račun je punovažan bez pečata i potpisa."), _c('br'), _vm._v("Izdavalac računa nije obaveznik PDV-a po članu 33. Zakona o PDV.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('span', [_vm._v("·")])])
}]}

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clients"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table table-hover table-responsive"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.clientState.clients), function(client) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(client.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.taxNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.registrationNumber))]), _vm._v(" "), _c('td', {
      staticClass: "shrink-column"
    }, [_c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button",
        "data-toggle": "modal",
        "data-target": "#client-modal"
      },
      on: {
        "click": function($event) {
          return _vm.edit(client.id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-18"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.remove(client.id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-18"
    }, [_vm._v("delete")])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    ref: "clientModal",
    staticClass: "modal fade",
    attrs: {
      "id": "client-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Naziv")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.name),
      expression: "currentClient.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Adresa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.address),
      expression: "currentClient.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("PIB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.taxNumber),
      expression: "currentClient.taxNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.taxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "taxNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Matični broj")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentClient.registrationNumber),
      expression: "currentClient.registrationNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentClient.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentClient, "registrationNumber", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveOrUpdate
    }
  }, [_vm._v("Sačuvaj")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Klijenti")]), _vm._v(" "), _c('p', [_vm._v("Baza firmi sa kojima se sarađuje.")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#client-modal"
    }
  }, [_vm._v("Dodaj klijenta")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Naziv")]), _vm._v(" "), _c('th', [_vm._v("Adresa")]), _vm._v(" "), _c('th', [_vm._v("PIB")]), _vm._v(" "), _c('th', [_vm._v("Matični broj")]), _vm._v(" "), _c('th', {
    staticClass: "shrink-column"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Klijent")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Firma")]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_vm._v("Naziv")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.name),
      expression: "settingState.company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Pun naziv firme.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Adresa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.address),
      expression: "settingState.company.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Vlasnik")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.owner),
      expression: "settingState.company.owner"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.owner)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "owner", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("PIB")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.taxNumber),
      expression: "settingState.company.taxNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.taxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "taxNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Matični broj")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.registrationNumber),
      expression: "settingState.company.registrationNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "registrationNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Šifra delatnosti")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.classificationCode),
      expression: "settingState.company.classificationCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.classificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "classificationCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Tekući račun")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.bankAccount),
      expression: "settingState.company.bankAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.bankAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "bankAccount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Odgovorno lice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.responsiblePerson),
      expression: "settingState.company.responsiblePerson"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.responsiblePerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "responsiblePerson", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Telefon")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.phoneNumber),
      expression: "settingState.company.phoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "phoneNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Web")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.website),
      expression: "settingState.company.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.company.email),
      expression: "settingState.company.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.company.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.company, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "mb-4"
  }), _vm._v(" "), _c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Računi")]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Podrazumevano mesto izdavanja")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.invoice.defaultIssuePlace),
      expression: "settingState.invoice.defaultIssuePlace"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settingState.invoice.defaultIssuePlace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.invoice, "defaultIssuePlace", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Podrazumevani rok za plaćanje")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingState.invoice.defaultPaymentDeadline),
      expression: "settingState.invoice.defaultPaymentDeadline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.settingState.invoice.defaultPaymentDeadline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settingState.invoice, "defaultPaymentDeadline", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "mb-4"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Sačuvaj")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Podešavanja")]), _vm._v(" "), _c('p', [_vm._v("Opšti podaci o firmi i računima.")])])])
}]}

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-book-preview mx-auto"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', {
    staticClass: "text-center mb-5"
  }, [_vm._v("Obrazac KPO")]), _vm._v(" "), _c('p', [_vm._v("PIB: " + _vm._s(_vm.company.taxNumber))]), _vm._v(" "), _c('p', [_vm._v("Obaveznik: " + _vm._s(_vm.company.owner))]), _vm._v(" "), _c('p', [_vm._v("Firma-radnje: " + _vm._s(_vm.company.name))]), _vm._v(" "), _c('p', [_vm._v("Sedište: " + _vm._s(_vm.company.address))]), _vm._v(" "), _c('p', [_vm._v("Šifra poreskog obveznika: " + _vm._s(_vm.company.registrationNumber))]), _vm._v(" "), _c('p', [_vm._v("Šifra delatnosti: " + _vm._s(_vm.company.classificationCode))]), _vm._v(" "), _c('h2', {
    staticClass: "text-center mb-5 mt-5"
  }, [_vm._v("Knjiga o ostvarenom prometu paušalno oporezovanih obveznika")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered mb-5"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(invoice.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(invoice.deliveryDate)) + " " + _vm._s(invoice.client.name))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("decimal")(invoice.total)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("decimal")(invoice.total)))])])
  }), 0)]), _vm._v(" "), _c('p', [_vm._v("Sastavio: " + _vm._s(_vm.company.owner))]), _vm._v(" "), _c('p', [_vm._v("Odgovorno lice: " + _vm._s(_vm.company.owner))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col",
      "rowspan": "2"
    }
  }, [_vm._v("Redni broj")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col",
      "rowspan": "2"
    }
  }, [_vm._v("Datum i opis knjiženja")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col",
      "colspan": "2",
      "rowspan": "1"
    }
  }, [_vm._v("Prihod od delatnosti")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col",
      "rowspan": "2"
    }
  }, [_vm._v("Svega prihodi od delatnosti")])]), _vm._v(" "), _c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("od prodaje proizvoda")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("od izvršenih usluga")])])])
}]}

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card mb-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Zarada")]), _vm._v(" "), _c('h6', {
    staticClass: "card-subtitle mb-2 text-muted"
  }, [_vm._v("Ukupan priliv")]), _vm._v(" "), _c('p', {
    staticClass: "card-text display-4"
  }, [_vm._v(_vm._s(_vm._f("decimal")(_vm.totalIncome)))])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Priliv u poslednjih 365 dana")]), _vm._v(" "), _c('p', {
    staticClass: "card-text display-4"
  }, [_vm._v(_vm._s(_vm._f("decimal")(_vm.rolling365Income)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Priliv po godini")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, _vm._l((_vm.incomePerYear), function(item) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('strong', [_vm._v(_vm._s(item.year))]), _vm._v(" " + _vm._s(_vm._f("decimal")(item.income)))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Dugovanja")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm._f("decimal")(_vm.totalDebt)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "img-fluid w-25",
    attrs: {
      "src": __webpack_require__(197)
    }
  })])])
}]}

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoices"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table table-responsive"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('tbody', [_c('tr', {
      staticClass: "table-secondary text-center"
    }, [_c('th', {
      attrs: {
        "scope": "row",
        "colspan": "7"
      }
    }, [_c('h3', [_vm._v(_vm._s(year))])])]), _vm._v(" "), _vm._l((_vm.groupedInvoices[year]), function(invoice) {
      return _c('tr', [_c('th', {
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(invoice.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.client.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((invoice.type === 'invoice') ? 'Račun' : ((invoice.type === 'proinvoice') ? 'Predračun' : '?')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(invoice.issueDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(invoice.total)))]), _vm._v(" "), _c('td', [(!invoice.referenceInvoice) ? [(!_vm.isInvoicePaid(invoice)) ? _c('p', {
        staticClass: "mb-1"
      }, [_c('span', {
        staticClass: "badge",
        class: [_vm.isDeadlinePassed(invoice.paymentDeadline.toDate()) ? 'badge-danger' : 'badge-light']
      }, [_vm._v("Rok: " + _vm._s(_vm._f("fromNow")(invoice.paymentDeadline.toDate())))])]) : _vm._e(), _vm._v(" "), _c('table', {
        staticClass: "table table-sm small",
        staticStyle: {
          "width": "auto",
          "margin-bottom": "0"
        }
      }, [_c('tbody', _vm._l((invoice.payments), function(payment, index) {
        return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(payment.date)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right"
        }, [_vm._v(_vm._s(_vm._f("money")(payment.amount)))]), _vm._v(" "), _c('td', {
          staticClass: "shrink-column"
        }, [_c('button', {
          staticClass: "btn btn-light btn-xs",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.removePayment(invoice.id, index)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("close")])])])])
      }), 0)]), _vm._v(" "), (!_vm.isInvoicePaid(invoice)) ? _c('button', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "type": "button",
          "data-toggle": "modal",
          "data-target": "#payment-modal"
        },
        on: {
          "click": function($event) {
            return _vm.showAddPayment(invoice.id)
          }
        }
      }, [_vm._v("Dodaj uplatu")]) : _vm._e(), _vm._v(" "), (invoice.type === 'proinvoice') ? _c('button', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "type": "button",
          "data-toggle": "modal",
          "data-target": "#pro2invoice-modal"
        },
        on: {
          "click": function($event) {
            return _vm.showConvertProToInvoice(invoice.id)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons md-18"
      }, [_vm._v("assignment")]), _vm._v(" Napravi račun")]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "shrink-column"
      }, [_c('router-link', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "to": {
            path: '/invoices/' + invoice.id
          },
          "exact": ""
        }
      }, [_c('i', {
        staticClass: "material-icons md-18"
      }, [_vm._v("open_in_new")])]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.removeInvoice(invoice.id)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons md-18"
      }, [_vm._v("delete")])])], 1)])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "paymentModal",
    staticClass: "modal fade",
    attrs: {
      "id": "payment-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Datum")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control form-control-sm",
    model: {
      value: (_vm.currentPayment.date),
      callback: function($$v) {
        _vm.$set(_vm.currentPayment, "date", $$v)
      },
      expression: "currentPayment.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Iznos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPayment.amount),
      expression: "currentPayment.amount"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.currentPayment.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPayment, "amount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePayment
    }
  }, [_vm._v("Sačuvaj")])])])])]), _vm._v(" "), _c('div', {
    ref: "pro2InvoiceModal",
    staticClass: "modal fade",
    attrs: {
      "id": "pro2invoice-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Faktura " + _vm._s(_vm.nextInvoiceNumber))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Datum izdavanja")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control form-control-sm",
    model: {
      value: (_vm.currentInvoice.issueDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "issueDate", $$v)
      },
      expression: "currentInvoice.issueDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Datum prometa")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control form-control-sm",
    model: {
      value: (_vm.currentInvoice.deliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "deliveryDate", $$v)
      },
      expression: "currentInvoice.deliveryDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Rok za plaćanje")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.paymentDeadline),
      expression: "currentInvoice.paymentDeadline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.currentInvoice.paymentDeadline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "paymentDeadline", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Napomena")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.note),
      expression: "currentInvoice.note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.currentInvoice.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.convertProToInvoice
    }
  }, [_vm._v("Napravi račun")])])])])]), _vm._v(" "), _c('div', {
    ref: "invoiceModal",
    staticClass: "modal fade",
    attrs: {
      "id": "invoice-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Faktura " + _vm._s(_vm.nextInvoiceNumber))]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.type),
      expression: "currentInvoice.type"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "invoice"
    },
    domProps: {
      "checked": _vm._q(_vm.currentInvoice.type, "invoice")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.currentInvoice, "type", "invoice")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Račun")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.type),
      expression: "currentInvoice.type"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "proinvoice"
    },
    domProps: {
      "checked": _vm._q(_vm.currentInvoice.type, "proinvoice")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.currentInvoice, "type", "proinvoice")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Predračun")])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Klijent")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.client),
      expression: "currentInvoice.client"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentInvoice, "client", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.clientState.clients), function(client) {
    return _c('option', {
      domProps: {
        "value": client
      }
    }, [_vm._v(_vm._s(client.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Datum izdavanja")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    model: {
      value: (_vm.currentInvoice.issueDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "issueDate", $$v)
      },
      expression: "currentInvoice.issueDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Mesto izdavanja")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.issuePlace),
      expression: "currentInvoice.issuePlace"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentInvoice.issuePlace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "issuePlace", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentInvoice.type === 'invoice'),
      expression: "currentInvoice.type === 'invoice'"
    }],
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Datum prometa")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    model: {
      value: (_vm.currentInvoice.deliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "deliveryDate", $$v)
      },
      expression: "currentInvoice.deliveryDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Rok za plaćanje")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.paymentDeadline),
      expression: "currentInvoice.paymentDeadline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.currentInvoice.paymentDeadline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "paymentDeadline", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_vm._v("Napomena")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.note),
      expression: "currentInvoice.note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.currentInvoice.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-responsive table-sm mt-4"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.currentInvoice.items), function(item, index) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "w-50"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "form-control form-control-sm form-control-plaintext",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      staticClass: "form-control form-control-sm form-control-plaintext",
      attrs: {
        "type": "number",
        "min": "1",
        "step": "1"
      },
      domProps: {
        "value": (item.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantity", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.price),
        expression: "item.price"
      }],
      staticClass: "form-control form-control-sm form-control-plaintext",
      attrs: {
        "type": "number",
        "step": "0.01"
      },
      domProps: {
        "value": (item.price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "price", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((item.quantity * item.price))))]), _vm._v(" "), _c('td', {
      staticClass: "shrink-column"
    }, [_c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeInvoiceItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-18"
    }, [_vm._v("delete")])])])])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addInvoiceItem
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("add")]), _vm._v(" Dodaj stavku")]), _vm._v(" "), _c('h3', {
    staticClass: "text-right mt-4"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Ukupno")]), _vm._v(" " + _vm._s(_vm._f("money")(_vm.currentInvoiceTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveInvoice
    }
  }, [_vm._v("Sačuvaj")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Fakture")]), _vm._v(" "), _c('p', [_vm._v("Pregled i kreiranje faktura.")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#invoice-modal"
    }
  }, [_vm._v("Kreiraj fakturu")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Klijent")]), _vm._v(" "), _c('th', [_vm._v("Tip")]), _vm._v(" "), _c('th', [_vm._v("Datum izdavanja")]), _vm._v(" "), _c('th', [_vm._v("Ukupno")]), _vm._v(" "), _c('th', [_vm._v("Uplate")]), _vm._v(" "), _c('th', {
    staticClass: "shrink-column"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Nova uplata")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('div', {
    staticClass: "input-group-text"
  }, [_vm._v("dana")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('div', {
    staticClass: "input-group-text"
  }, [_vm._v("dana")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Naziv usluge")]), _vm._v(" "), _c('th', [_vm._v("Količina")]), _vm._v(" "), _c('th', [_vm._v("Cena")]), _vm._v(" "), _c('th', [_vm._v("Ukupno")]), _vm._v(" "), _c('th', {
    staticClass: "shrink-column"
  })])])
}]}

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark d-print-none"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("joshefin.xyz")]), _vm._v(" "), (_vm.currentUser.email) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "main-navbar"
    }
  }, [_c('div', {
    staticClass: "navbar-nav"
  }, [_c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/invoices",
      "exact": "",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v("Fakture")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/clients",
      "exact": "",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v("Klijenti")]), _vm._v(" "), _c('div', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("KPO")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.years), function(year) {
    return _c('router-link', {
      key: year,
      staticClass: "dropdown-item",
      attrs: {
        "to": {
          path: '/sales/' + year
        },
        "exact": ""
      }
    }, [_vm._v(_vm._s(year))])
  }), 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item nav-link",
    attrs: {
      "to": "/settings",
      "exact": "",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse.show"
    }
  }, [_vm._v("Podešavanja")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-nav ml-auto"
  }, [(_vm.currentUser.email) ? _c('div', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18 align-middle"
  }, [_vm._v("person")]), _vm._v(" " + _vm._s(_vm.currentUser.email) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.signout
    }
  }, [_vm._v("Odjava")])])]) : _vm._e()])])] : _vm._e()], 2), _vm._v(" "), _c('main', [_c('keep-alive', [(_vm.initialized) ? _c('router-view') : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#main-navbar",
      "aria-controls": "main-navbar",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signin"
  }, [_c('div', {
    staticClass: "container mt-5"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-4 col-8 text-center"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Prijava")]), _vm._v(" "), _c('form', {
    staticClass: "mt-4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Šifra"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Prijavi se")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);



__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
	apiKey: 'AIzaSyBDXFbL07I2cTzGqnIziVUrvjgdru0L5bU',
	authDomain: 'invoices-c4ea5.firebaseapp.com',
	databaseURL: 'https://invoices-c4ea5.firebaseio.com',
	projectId: 'invoices-c4ea5',
	storageBucket: '',
	messagingSenderId: '67359475115'
});

var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();

db.settings({
	timestampsInSnapshots: true
});


var auth = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth();

/***/ })

},[214]);


// WEBPACK FOOTER //
// static/js/app.f90439e221b6ff608a21.js